// Palette fixe de couleurs joueurs, choisies pour être bien distinctes
// et lisibles sur une carte (fond clair comme foncé).
export const PLAYER_COLORS = [
  { value: '#e6194b', label: 'Rouge' },
  { value: '#f58231', label: 'Orange' },
  { value: '#ffad23', label: 'Ambre' },
  { value: '#3cb44b', label: 'Vert' },
  { value: '#2bb5a0', label: 'Turquoise' },
  { value: '#4363d8', label: 'Bleu' },
  { value: '#911eb4', label: 'Violet' },
  { value: '#f032e6', label: 'Magenta' },
  { value: '#9a6324', label: 'Brun' },
  { value: '#469990', label: 'Sarcelle' },
];

// Repli déterministe quand le joueur n'a pas choisi de couleur :
// on pioche une teinte stable de la palette à partir de son uid.
export const colorFromUid = (uid = '') => {
  let h = 0;
  for (let i = 0; i < uid.length; i++) h = (h * 31 + uid.charCodeAt(i)) % 2147483647;
  return PLAYER_COLORS[h % PLAYER_COLORS.length].value;
};
